import { useQuery } from 'apollo-3';

import { classroomSubSectionContent } from 'GraphQL/query/Classroom.query';

const useSubsectionContent = (apolloProps) => {
  const queryResult = useQuery(classroomSubSectionContent, apolloProps);
  return queryResult;
};

export default useSubsectionContent;
